import { readStoredUser } from "../utils/userSession";
import React, { useState } from "react";
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import CandidateScheduleDialog from "./CandidateScheduleDialog";
import { interviewsChanged, schedulingRequest } from "../utils/interviewScheduling";

export default function ScheduledMeetingActions({ record, onSaved }) {
  const [editor, setEditor] = useState(null);
  const [cancelOpen, setCancelOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [cancelled, setCancelled] = useState(false);
  const user = readStoredUser();
  const canManage = record?.can_manage ?? (record?.actor_user_id != null && String(record.actor_user_id) === String(user?.id ?? user?.user_id));
  if (!record?.calendar_event_id || !canManage) return null;
  const discovery = record.review_kind === "discovery_call";
  const changed = () => { interviewsChanged(); Promise.resolve(onSaved?.()).catch(err => setError(err.message)); };
  async function edit(mode) {
    setBusy(true); setError("");
    try {
      const { meeting } = await schedulingRequest(`/calendar/meetings/${record.id}`);
      if (meeting.interview_status === "cancelled") { setCancelled(true); changed(); throw new Error("This meeting has been cancelled."); }
      setEditor({ meeting, mode });
    } catch (err) { setError(err.message); }
    finally { setBusy(false); }
  }
  async function cancel() {
    setBusy(true); setError("");
    try {
      await schedulingRequest(`/calendar/${discovery ? "discovery-calls" : "interviews"}/${record.id}`, { method: "PATCH", body: JSON.stringify({ action: "cancel" }) });
      setCancelled(true); setCancelOpen(false); changed();
    } catch (err) { setError(err.message); }
    finally { setBusy(false); }
  }
  return <>
    {!cancelled && record.interview_status !== "cancelled" && <>
      <Button size="small" disabled={busy} onClick={() => edit("edit")}>Edit</Button>
      <Button size="small" disabled={busy} onClick={() => edit("reschedule")}>Reschedule</Button>
      <Button size="small" color="error" disabled={busy} onClick={() => setCancelOpen(true)}>Cancel</Button>
    </>}
    {error && !cancelOpen && <Alert severity="error">{error}</Alert>}
    {editor && <CandidateScheduleDialog open mode={editor.mode} initialEvent={editor.meeting}
      context={{ kind: discovery ? "discovery" : "interview", leadId: editor.meeting.lead_id }}
      onClose={() => setEditor(null)} onSaved={changed} />}
    <Dialog open={cancelOpen} onClose={busy ? undefined : () => setCancelOpen(false)}>
      <DialogTitle data-popup-header>Cancel meeting?</DialogTitle>
      <DialogContent>This cancels the calendar event and notifies invited attendees.{error && <Alert severity="error">{error}</Alert>}</DialogContent>
      <DialogActions data-popup-footer><Button disabled={busy} onClick={() => setCancelOpen(false)}>Keep meeting</Button><Button disabled={busy} color="error" onClick={cancel}>Cancel meeting</Button></DialogActions>
    </Dialog>
  </>;
}
